<template>
<v-app style="background:#FBFBFB;text-align:justify;padding:5%;">
<v-btn text color="black" to="/">&lt;&nbsp;zur&uuml;ck</v-btn>
<br/><h1>Impressum</h1><br/>
<h2>Angaben gem&auml;&szlig; &sect; 5 TMG</h2>
<p>Karobube<br />
Simon Reuter<br />
c/o IP-Management #9162<br />
Ludwig-Erhard-Str. 18<br />
20459 Hamburg
<br/>
<br/>Hierbei handelt es sich um eine ladungsfähige Nebenadresse zum Privatadressenschutz. Die Mitteilung der Rechnungs- und Meldeanschrift für den Geschäftsverkehr erfolgt auf Anfrage. Vielen Dank für Ihr Verständnis.</p>

<h2>Kontakt</h2>
<p>Telefon: 06421 3800 306<br />
Mobil: 0160 9345 7665<br />
E-Mail: contact@karobube.com</p>

<h2>Steuer</h2>
<p>USt-IdNr.: DE445342043<br/>
W-IdNr.: DE445342043-00001</p>
  </v-app>
</template>

<script>
export default {
  name: 'Impressum'
};
</script>

<style scoped>
.logo {
  width: 70%;
  max-width: 700px;
  margin: 5% 5% 2% 5%;
}
.bottom-right {
  position: absolute;
  bottom: 0px;
  right: 0px;
  margin: 1% 1% 1%;
}
.text {
  color: white;
  max-width: 100%;
}
</style>
